import { render } from "./IframeRedirect.vue?vue&type=template&id=264ffa24&ts=true"
import script from "./IframeRedirect.vue?vue&type=script&lang=ts"
export * from "./IframeRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__